import { css, cx } from '@emotion/css'
import { theme } from '../styles/theme.js'
import { Card } from '../components/Card.jsx'
import { Button } from '../components/Button.jsx'

const styles = {
  container: css({
    paddingTop: theme.spacing.sm,
  }),
  title: css({
    fontSize: theme.typography.fontSize.xxl,
    fontWeight: 700,
    marginBottom: theme.spacing.lg,
  }),
  grid: css({
    display: 'grid',
    gap: theme.spacing.md,
    gridTemplateColumns: '1fr',
    '@media (min-width: 480px)': {
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    },
  }),
  item: css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.sm,
  }),
  itemTitle: css({
    fontWeight: 600,
    fontSize: theme.typography.fontSize.lg,
  }),
  itemDesc: css({
    color: theme.colors.textMuted,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.relaxed,
  }),
}

const items = [
  { id: 1, title: 'The First Seed', desc: 'Everything starts here. Plant the initial idea.' },
  { id: 2, title: 'Root System', desc: 'Build deep foundations that will support growth.' },
  { id: 3, title: 'Branching Paths', desc: 'Explore multiple directions without losing focus.' },
  { id: 4, title: 'Canopy', desc: 'Let your work spread and provide shade for others.' },
]

const Explore = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Explore</h1>

      <div className={styles.grid}>
        {items.map((item) => (
          <Card key={item.id} className={styles.item}>
            <div className={styles.itemTitle}>{item.title}</div>
            <div className={styles.itemDesc}>{item.desc}</div>
            <div style={{ marginTop: 'auto', paddingTop: theme.spacing.md }}>
              <Button variant="secondary" style={{ width: '100%' }}>
                Enter
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  )
}

export { Explore }
